<script setup lang="ts">
import { getMaterialPublicId } from '~/shared/lib/getMaterialLink';
import type {
  INewsDataClientDTO,
  INewsItemDataClientDTO,
} from '~/shared/api/client/news/news.dto';

type INewsDataClientDTOWithExpert = Omit<INewsDataClientDTO, 'news'> & {
  news: INewsItemDataClientDTO | null;
};

const props = defineProps<INewsDataClientDTOWithExpert>();

const isExpert = computed(
  () => props.expert !== null && props.expert !== undefined,
);

const isRedirect = computed(() =>
  Boolean(props.news?.redirect && props.news.redirect.length > 0),
);

const link = computed(() => {
  if (isRedirect.value && props.news?.redirect) return props.news.redirect;
  if (isExpert.value) return `/expert/${getMaterialPublicId(props.expert!)}`;
  return `/${props.news?.type}/${props.news?.id}`;
});

const categoryLink = computed(() =>
  isExpert.value ? '/expert' : `/category/${props.news?.category?.id}`,
);
const categoryName = computed(() =>
  isExpert.value ? 'Мнения экспертов' : props.news?.category?.name,
);

const partnerCategory = computed(
  () => props.expert?.category ?? props.news?.category ?? null,
);
</script>

<template>
  <div :class="$style.item">
    <PartnerBadge
      :category="partnerCategory"
      :class="$style.item__partnerBadge"
    />

    <NuxtLink
      v-if="categoryName"
      :class="$style.item__category"
      :to="categoryLink"
    >
      {{ categoryName }}
    </NuxtLink>
    <NuxtLink
      :class="$style.item__title"
      :to="link"
      :target="!isExpert && isRedirect ? '_blank' : undefined"
    >
      {{ props.title }}
    </NuxtLink>
  </div>
</template>

<style lang="scss" module>
.item {
  display: flex;
  flex-flow: column nowrap;
  gap: var(--space-1x);
  position: relative;

  &__partnerBadge {
    position: absolute;
    top: var(--space-2-5x);
    right: var(--space-2-5x);
    z-index: 1;
  }

  &__category {
    display: block;
    @include text_caption2_caps;
    color: var(--color-gray-text);
    text-decoration: none;
  }

  &__title {
    display: block;
    @include text_h3;
    color: var(--color-black-1);
    text-decoration: none;
  }
}

@media (hover: hover) {
  .item {
    transition: all 0.2s;

    &:hover {
      opacity: 0.85;
    }
  }
}

@media (max-width: 1379px) {
  .item {
    &__title {
      @include text_h5;
    }
  }
}
</style>
